//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* jshint devel: true, jquery: true */
/* global angular: false, moment: true, window: false, _: false */

(function() {
  angular.module('curalate').factory('TaggerSanitization', () => ({
    sanitize(tag) {
      return crl8.shared.tags.sanitize(tag);
    },

    encode(tag) {
      return crl8.shared.tags.encode(tag);
    },

    valid(tag) {
      return crl8.shared.tags.valid(tag);
    },
  }));
})();
